import { useMemo } from "react";

import { ProjectDates } from "../../../../../../models";
import { GetProjectDetailsResponse } from "../../../../../../service/publicquery";
import { jsonReviver } from "../../../../../../utils";

interface DatesSectionProps {
  projectDetails: GetProjectDetailsResponse;
}

interface DatesSectionReturnData {
  projectDates?: ProjectDates;
}
export const useDatesSection = ({ projectDetails }: DatesSectionProps): DatesSectionReturnData => {
  const projectDates = useMemo(() => {
    if (!projectDetails?.dates) return undefined;

    const parsedJsonDates = JSON.parse(projectDetails.dates, jsonReviver) as ProjectDates;

    return {
      ...parsedJsonDates,
      ongoingMonitoring: {
        ...parsedJsonDates.ongoingMonitoring,
        cycles: parsedJsonDates.ongoingMonitoring?.cycles?.sort((a, b) => a.sequence - b.sequence) ?? [],
      },
    } as ProjectDates;
  }, [projectDetails.dates]);

  return {
    projectDates,
  };
};
